import React, { useState, useEffect } from "react";

interface ToggleSwitchProps {
  label: string;
  description?: string;
  checked: boolean; // Add checked prop
  onChange: (value: boolean) => void; // Add onChange handler
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  label,
  description,
  checked,
  onChange,
}) => {
  // You can remove local state if the parent is controlling it
  const [isChecked, setIsChecked] = useState(checked);

  // Update the local state when the checked prop changes
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleToggle = () => {
    setIsChecked(!isChecked);
    onChange(!isChecked); // Notify the parent component of the change
  };

  return (
    <div className="p-4 border border-blue-100 rounded-xl">
      <label className="inline-flex gap-4 cursor-pointer">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
          className="sr-only peer"
        />
        <div className="relative w-11 h-6 bg-blue-100 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-600 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
        <div>
          <span className="text-sm font-thin text-grease-100">{label}</span>
          {description && (
            <p className="mt-2 text-xs font-thin text-lightgray-150">
              {description}
            </p>
          )}
        </div>
      </label>
    </div>
  );
};

export default ToggleSwitch;
